<h3 class="page-header">Capacity Override</h3>
<form [formGroup]="overrideCapForm">
    <div class="row no-gutters">

        <div class="col-8 col-lg-6 calendarSection">
            <app-calendar [formControlName]="'selectedDate'" [dateDetails]="capacity$ | async" [minDate]="minDate">
            </app-calendar>
        </div>
        <app-capacity-override-card></app-capacity-override-card>
    </div>
</form>